import { render } from "./PoI.vue?vue&type=template&id=b3ab28b0"
import script from "./PoI.vue?vue&type=script&lang=js"
export * from "./PoI.vue?vue&type=script&lang=js"

import "./PoI.vue?vue&type=style&index=0&id=b3ab28b0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__